var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import RouterModule from '../router';
import { BaseModule } from './../commons/BaseModule';
import PublicDocument from './components/PublicDocument.vue';
var UsersModule = (function (_super) {
    __extends(UsersModule, _super);
    function UsersModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UsersModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.installRoutes(options);
            resolve(true);
        });
    };
    UsersModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    UsersModule.prototype.installRoutes = function (options) {
        var routerModule = options.appModule.getModuleByType(RouterModule);
        var complexRoutes = routerModule.complexRoutes;
        if (process.env.PUBLIC_DOCUMENT) {
            complexRoutes.addRawRouteAt('', {
                path: '',
                name: 'document',
                component: PublicDocument,
                props: true,
                meta: {
                    isRoot: true
                }
            });
        }
    };
    return UsersModule;
}(BaseModule));
export default UsersModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/documents/index.ts
// module id = null
// module chunks = 